export const environment = {
  production: false,
  apiBase: 'http://10.0.0.137:6006/'
};